import { adaptRecord, filterRecords, getRecords } from "../orm/records-mjs";

function getRecordsForTypes(types, args, mirageSchema) {
  return types.reduce(function (records, type) {
    return [].concat(records, getRecords(type, args, mirageSchema));
  }, []);
}

export default function resolveUnion(obj, args, context, info, isList, type) {
  return !obj ? getRecordsForTypes(type.getTypes(), args, context.mirageSchema) : isList ? filterRecords(obj[info.fieldName].models, args) : adaptRecord(obj[info.fieldName]);
}
